import TagManager from 'react-gtm-module';

export type ViewComponentLocation = 'cip' | 'clp';

export type ViewComponentType =
  | 'hero'
  | 'activity nav grid'
  | 'promo tiles'
  | 'learn strip'
  | 'hotspot'
  | 'brand tiles'
  | 'recommendation';

export const NOT_SET = '(not set)';

export interface TrackViewComponentProps {
  interactionLocation: ViewComponentLocation;
  type: ViewComponentType;
  heading: string;
  eventPage: string;
  index: number;
}

export const trackViewComponent = ({
  interactionLocation,
  type,
  heading,
  eventPage,
  index,
}: TrackViewComponentProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'view_component',
      interaction: {
        interaction_location: interactionLocation,
        type,
        heading,
        event_page: eventPage,
        index: index.toString(),
      },
    },
  });
};
